import React, { Component } from 'react';
import { Dashboard, LocalStorage, WidgetDefinition } from "@plcm/dynamic-dashboards"
import EndreasonPie from './widgets/EndreasonPie'
import DevicesPie from './widgets/DevicesPie'
import DevicesBar from './widgets/DevicesBar'
import ActiveCallsChart from './widgets/ActiveCallsChart'
import ActiveCallsPer from './widgets/ActiveCallsPer'
import TopConferences from './widgets/TopConferences'
import CallDuration from './widgets/CallDuration'
import ActiveCallsCount from './widgets/ActiveCallsCount'
import TotalCalls from './widgets/TotalCalls'
import TeamsCalls from './widgets/TeamsCalls'
import SkypeCalls from './widgets/SkypeCalls'
import TotalDuration from './widgets/TotalDuration'
import TeamsDuration from './widgets/TeamsDuration'
import SkypeDuration from './widgets/SkypeDuration'
import TotalMedian from './widgets/TotalMedian'
import TeamsMedian from './widgets/TeamsMedian'
import SkypeMedian from './widgets/SkypeMedian'
import TotalMax from './widgets/TotalMax'
import TeamsMax from './widgets/TeamsMax'
import SkypeMax from './widgets/SkypeMax'
import LicenseOverage from './widgets/LicenseOverage'
import LicenseRejected from './widgets/LicenseRejected'
import LicenseSurged from './widgets/LicenseSurged'
import ClaritiLicenseOverage from './widgets/ClaritiLicenseOverage'
import MostUsed from './widgets/MostUsed'
import { translate } from 'react-i18next'

class DynamicDashboard extends Component {
  constructor(props) {
    super(props);

    this.saveCallback = this.saveCallback.bind(this);

    let empty = false;
    let ls = localStorage.getItem(this.dbKey);
    if (ls === null || ls.length === 0) {
      empty = true;
    } else {
      let lsObj = JSON.parse(ls);
      if (lsObj.widgets && lsObj.widgets.length === 0) {
        empty = true;
      }
    }

    if (empty) {
      console.log("Creating new localStorage[" + this.dbKey + "] with defaults.");
      let widgetMap = {};
      this.widgetTypes.forEach((w) => widgetMap[w.name] = w);

      // get unique ids
      let idSet = new Set([]);
      for (let ii = 0; ii < this.defaultLayout.length; ii++) {
        let id = Math.floor(Math.random()*1000000000);
        if (idSet.has(id)) {
          ii--;
        } else {
          idSet.add(id);
        }
      }
      idSet = Array.from(idSet);
      let idIdx = 0;
      this.defaultLayout.forEach((w) => {
        w.i = idSet[idIdx++];
      });

      // create string object
      let obj = {"widgets":[], "layouts":{"md":[]}};
      this.defaultLayout.forEach((w) => {
        obj.widgets.push({id:w.i + "", name:w.widget});
        obj.layouts.md.push({w:w.w, h:w.h, x:w.x, y:w.y, i:w.i + "", moved:false, static:false,
            minW:widgetMap[w.widget].defaultGridItemProps.w,
            maxW:widgetMap[w.widget].defaultGridItemProps.maxW,
            minH:widgetMap[w.widget].defaultGridItemProps.h,
            maxH:widgetMap[w.widget].defaultGridItemProps.maxH
        });
      });
      localStorage.setItem(this.dbKey,JSON.stringify(obj));
    }
  }

  dbKey = "aquaAnalyticsDashboard";

  defaultLayout = [
    { widget: "EndReasonPie",     w:4, h:12, x:0, y:0 },
    { widget: "ActiveCallsPer",   w:4, h:12, x:4, y:0 },
    { widget: "TotalCalls",       w:2, h:4,  x:0, y:13 },
    { widget: "TotalDuration",    w:2, h:4,  x:2, y:13 },
    { widget: "TotalMedian",      w:2, h:4,  x:4, y:13 },
    { widget: "TotalMax",         w:2, h:4,  x:6, y:13 },
    { widget: "TeamsCalls",       w:2, h:4,  x:0, y:15 },
    { widget: "TeamsDuration",    w:2, h:4,  x:2, y:15 },
    { widget: "TeamsMedian",      w:2, h:4,  x:4, y:15 },
    { widget: "TeamsMax",         w:2, h:4,  x:6, y:15 },
    { widget: "SkypeCalls",       w:2, h:4,  x:0, y:17 },
    { widget: "SkypeDuration",    w:2, h:4,  x:2, y:17 },
    { widget: "SkypeMedian",      w:2, h:4,  x:4, y:17 },
    { widget: "SkypeMax",         w:2, h:4,  x:6, y:17 },
    { widget: "DevicesPie",       w:4, h:12, x:0, y:19 }, 
    { widget: "DevicesBar",       w:4, h:12, x:4, y:19 }, 
    { widget: "TopConferences",   w:4, h:12, x:0, y:31 }, 
    { widget: "CallDuration",     w:4, h:12, x:4, y:31 }, 
    { widget: "ActiveCallsChart", w:4, h:12, x:0, y:43 }, 
    { widget: "ActiveCallsCount", w:2, h:4,  x:4, y:43 }, 
    { widget: "LicenseOverage",   w:2, h:4,  x:6, y:43 }, 
    { widget: "LicenseRejected",  w:2, h:4,  x:4, y:47 }, 
    { widget: "LicenseSurged",    w:2, h:4,  x:6, y:47 },
    { widget: "ClaritiLicenseOverage", w:2, h:4,  x:4, y:51 },
    { widget: "MostUsed",         w:4, h:12, x:0, y:55 }
  ]

  widgetTypes = [
    new WidgetDefinition("EndReasonPie", EndreasonPie),
    new WidgetDefinition("DevicesPie", DevicesPie),
    new WidgetDefinition("DevicesBar", DevicesBar),
    new WidgetDefinition("ActiveCallsChart", ActiveCallsChart),
    new WidgetDefinition("ActiveCallsPer", ActiveCallsPer),
    new WidgetDefinition("TopConferences", TopConferences),
    new WidgetDefinition("CallDuration", CallDuration),
    new WidgetDefinition("ActiveCallsCount", ActiveCallsCount),
    new WidgetDefinition("TotalCalls", TotalCalls),
    new WidgetDefinition("TotalDuration", TotalDuration),
    new WidgetDefinition("TotalMedian", TotalMedian),
    new WidgetDefinition("TotalMax", TotalMax),
    new WidgetDefinition("TeamsCalls", TeamsCalls),
    new WidgetDefinition("TeamsDuration", TeamsDuration),
    new WidgetDefinition("TeamsMedian", TeamsMedian),
    new WidgetDefinition("TeamsMax", TeamsMax),
    new WidgetDefinition("SkypeCalls", SkypeCalls),
    new WidgetDefinition("SkypeDuration", SkypeDuration),
    new WidgetDefinition("SkypeMedian", SkypeMedian),
    new WidgetDefinition("SkypeMax", SkypeMax),
    new WidgetDefinition("LicenseOverage", LicenseOverage),
    new WidgetDefinition("LicenseRejected", LicenseRejected),
    new WidgetDefinition("LicenseSurged", LicenseSurged),
    new WidgetDefinition("ClaritiLicenseOverage", ClaritiLicenseOverage),
    new WidgetDefinition("MostUsed", MostUsed)
  ];

  dbStorage = new LocalStorage(this.dbKey);

  saveCallback(layoutsObj, widgetsObj) {
    // checking to see if the when layouts prop is enabled ... check out index.js2
    console.log("EDIT ME NOW: New layouts[%O] and widgets [%O]",layoutsObj, widgetsObj);
  }

  render() {
    return (
      <Dashboard key="board"
        filters={[]}
        widgetTypes={this.widgetTypes}
        layoutStorage={this.dbStorage}
        saveCallback={this.saveCallback}
      />
    );
  }
}

export default translate()(DynamicDashboard);
